
// src/utils/mockData.js

import hourglass from '../assets/images/hourglass.jpg'
import memento from '../assets/images/memento.jpg'
import concertante from '../assets/images/concertante.jpg'
import time2fly from '../assets/images/time2fly.jpg'
import traumereiJpg from '../assets/images/traumerei.jpg'
import teoTess from '../assets/images/teotess.jpg'
import ampulexJpg from '../assets/images/ampulex.jpg'
import vitae from '../assets/images/vitae.jpg'
import triplets from '../assets/images/triplets.jpg'
import terequiemJpg from '../assets/images/terequiem.jpg'

import abandonedBoy from '../assets/audio/hourglass/1ABANDONEDBOY.wav'
import aBeautifulLifeAhead from '../assets/audio/hourglass/2ABEAUTIFULLIFEAHEAD.wav'
import songOfHypatia from '../assets/audio/hourglass/3SONGOFHYPATIA.wav'
import theChildrenOfDoggerland from '../assets/audio/hourglass/4THECHILDRENOFDOGGERLAND.wav'
import dreamLoop from '../assets/audio/hourglass/5DREAMLOOP.wav'
import hallonFlickan from '../assets/audio/hourglass/6HALLONFLICKAN.wav'

import mementoMori from '../assets/audio/memento/memento.wav'

import sinfoniaConcertante from '../assets/audio/sinfonia/sinfonia.wav'

import timeToFly from '../assets/audio/timetoflyisawher/timetofly.wav'
import iSawHer from '../assets/audio/timetoflyisawher/isawher.wav'

import etude16 from '../assets/audio/traumerei/etude16.wav'
import traumerei from '../assets/audio/traumerei/traumerei.wav'

import weddingWalz from '../assets/audio/teotess/weddingwalz.wav'
import teoTess1 from '../assets/audio/teotess/teotess1.wav'
import teoTess2 from '../assets/audio/teotess/teotess2.wav'

import ampulex from '../assets/audio/ampulex/ampulex.wav'

import awaken from '../assets/audio/vitae/awaken.wav'
import circus from '../assets/audio/vitae/circus.wav'
import cumulunimbus from '../assets/audio/vitae/cumulunimbus.wav'
import earthDance from '../assets/audio/vitae/earthdance.wav'
import ghostTown from '../assets/audio/vitae/ghosttown.wav'
import hiddenLight from '../assets/audio/vitae/hiddenlight.wav'
import jealousy from '../assets/audio/vitae/jealousy.wav'
import roadToNothing from '../assets/audio/vitae/roadtonothing.wav'
import birkJulia from '../assets/audio/vitae/birkjulia.wav'

import birk from '../assets/audio/triplets/birk.wav'
import jonathan from '../assets/audio/triplets/jonathan.wav'
import nathanael from '../assets/audio/triplets/nathanael.wav'

import terequiem from '../assets/audio/terequiem/terequiem.wav'


export const mockReleases = [
    {
      id: 1,
      title: "Hourglass of Lost Voices",
      coverImage: hourglass,
      releaseDate: "2025-04-11",
      description: "A piece for solo violin and orchestra"
    },
    {
      id: 2,
      title: "Memento Mori",
      coverImage: memento,
      releaseDate: "2022-12-16",
      description: "For string orchestra"
    },
    {
      id: 4,
      title: "Time to Fly, my Little Bird / I Saw Her",
      coverImage: time2fly,
      releaseDate: "2022-07-31",
      description: "A piece for solo violin and chamber orchestra"
    },
    {
      id: 3,
      title: "Sinfonia Concertante",
      coverImage: concertante,
      releaseDate: "2022-07-21",
      description: "A piece for solo violin, solo viola and orchestra"
    },
    {
        id: 5,
        title: "Traumerei / Etude 16",
        coverImage: traumereiJpg,
        releaseDate: "2021-10-22",
        description: "Two pieces for solo violin"
      },
      {
        id: 6,
        title: "Herrafällan Wedding Walz / Teo & Tess",
        coverImage: teoTess,
        releaseDate: "2020-10-23",
        description: "For string quartet"
      },
      {
        id: 7,
        title: "Ampulex Compressa",
        coverImage: ampulexJpg,
        releaseDate: "2020-08-07",
        description: "For string quartet"
      },
      {
        id: 8,
        title: "Vitae Obscura",
        coverImage: vitae,
        releaseDate: "2019-09-22",
        description: "Trio for flute, violin and cello"
      },
      {
        id: 10,
        title: "Terequiem",
        coverImage: terequiemJpg,
        releaseDate: "2020-11-30",
        description: "For string quartet"
      },
      {
        id: 9,
        title: "Dance of the Triplets",
        coverImage: triplets,
        releaseDate: "2019-05-25",
        description: "Duet for violin and cello"
      }
  ];
  
  export const mockTracks = [
    // Album 1
    {
      id: 1,
      releaseId: 1,
      title: "The Abandoned Boy",
      musicFilePath: abandonedBoy,
      trackNumber: 1
    },
    {
      id: 2,
      releaseId: 1,
      title: "A Beautiful Life Ahead",
      musicFilePath: aBeautifulLifeAhead,
      trackNumber: 2
    },
    {
      id: 3,
      releaseId: 1,
      title: "Song of Hypatia",
      musicFilePath: songOfHypatia,
      trackNumber: 3
    },
    
    {
      id: 4,
      releaseId: 1,
      title: "The Children of Doggerland",
      musicFilePath: theChildrenOfDoggerland,
      trackNumber: 4
    },
    {
      id: 5,
      releaseId: 1,
      title: "Dream Loop",
      musicFilePath: dreamLoop,
      trackNumber: 5
    },
    {
      id: 6,
      releaseId: 1,
      title: "The Raspberry Girl",
      musicFilePath: hallonFlickan,
      trackNumber: 6
    },
    {
      id: 7,
      releaseId: 2,
      title: "Memento Mori",
      musicFilePath: mementoMori,
      trackNumber: 1
    },
    {
      id: 8,
      releaseId: 3,
      title: "Sinfonia Concertante",
      musicFilePath: sinfoniaConcertante,
      trackNumber: 1
    },
    {
        id: 9,
        releaseId: 4,
        title: "Time to Fly, my Little Bird",
        musicFilePath: timeToFly,
        trackNumber: 1
      },
      {
        id: 10,
        releaseId: 4,
        title: "I Saw Her",
        musicFilePath: iSawHer,
        trackNumber: 2
      },
      {
        id: 11,
        releaseId: 5,
        title: "Traumerei",
        musicFilePath: traumerei,
        trackNumber: 1
      },
      {
        id: 12,
        releaseId: 5,
        title: "Etude 16",
        musicFilePath: etude16,
        trackNumber: 2
      },
      {
        id: 13,
        releaseId: 6,
        title: "Herrafällan Wedding Walz",
        musicFilePath: weddingWalz,
        trackNumber: 1
      },
      {
        id: 14,
        releaseId: 6,
        title: "Teo & Tess, Movement 1",
        musicFilePath: teoTess1,
        trackNumber: 2
      },
      {
        id: 15,
        releaseId: 6,
        title: "Teo & Tess, Movement 2",
        musicFilePath: teoTess2,
        trackNumber: 3
      },
      {
        id: 16,
        releaseId: 7,
        title: "Ampulex Compressa",
        musicFilePath: ampulex,
        trackNumber: 1
      },
      {
        id: 17,
        releaseId: 8,
        title: "Awaken",
        musicFilePath: awaken,
        trackNumber: 1
      },
      {
        id: 18,
        releaseId: 8,
        title: "Circus of Circumstance",
        musicFilePath: circus,
        trackNumber: 8
      },
      {
        id: 19,
        releaseId: 8,
        title: "Cumulunimbus Incus",
        musicFilePath: cumulunimbus,
        trackNumber: 9
      },
      {
        id: 20,
        releaseId: 8,
        title: "Earth Dance",
        musicFilePath: earthDance,
        trackNumber: 4
      },
      {
        id: 21,
        releaseId: 8,
        title: "Ghost Town",
        musicFilePath: ghostTown,
        trackNumber: 2
      },
      {
        id: 22,
        releaseId: 8,
        title: "Hidden Light",
        musicFilePath: hiddenLight,
        trackNumber: 5
      },
      {
        id: 23,
        releaseId: 8,
        title: "Jealousy",
        musicFilePath: jealousy,
        trackNumber: 3
      },
      {
        id: 24,
        releaseId: 8,
        title: "Road to Nothing",
        musicFilePath: roadToNothing,
        trackNumber: 7
      },
      {
        id: 25,
        releaseId: 8,
        title: "Wedding Walz for Birk & Julia",
        musicFilePath: birkJulia,
        trackNumber: 6
      },
      {
        id: 26,
        releaseId: 9,
        title: "Birk",
        musicFilePath: birk,
        trackNumber: 1
      },
      {
        id: 27,
        releaseId: 9,
        title: "Jonathan",
        musicFilePath: jonathan,
        trackNumber: 2
      },   
    {
        id: 28,
        releaseId: 9,
        title: "Nathanael",
        musicFilePath: nathanael,
        trackNumber: 3
      },
      {
        id: 28,
        releaseId: 10,
        title: "Terequiem",
        musicFilePath: terequiem,
        trackNumber: 1
      },
  ];
  
  export const mockContributors = [
    {
      id: 1,
      name: "Johannes Hjort",
      releaseId: 2,
      contribution: "Photographer"
    },
    {
        id: 2,
        name: "Esbjörn Falk",
        releaseId: 6,
        contribution: "Composer, Violin 1"
      },
      {
        id: 3,
        name: "Andreas Rosulnd",
        releaseId: 6,
        contribution: "Violin 2"
      },
      {
        id: 4,
        name: "Thomas Ringkvist",
        releaseId: 6,
        contribution: "Viola"
      },
      {
        id: 5,
        name: "Johan Kyllmar",
        releaseId: 6,
        contribution: "Cello"
      },
      {
        id: 6,
        name: "Esbjörn Falk",
        releaseId: 7,
        contribution: "Composer, Violin 1"
      },
      {
        id: 7,
        name: "Andreas Rosulnd",
        releaseId: 7,
        contribution: "Violin 2"
      },
      {
        id: 8,
        name: "Thomas Ringkvist",
        releaseId: 7,
        contribution: "Viola"
      },
      {
        id: 9,
        name: "Johan Kyllmar",
        releaseId: 7,
        contribution: "Cello"
      },
      {
        id: 10,
        name: "Esbjörn Falk",
        releaseId: 8,
        contribution: "Composer, Violin"
      },
      {
        id: 11,
        name: "Joanna Falk",
        releaseId: 8,
        contribution: "Flute"
      },
      {
        id: 12,
        name: "Johan Kyllmar",
        releaseId: 8,
        contribution: "Cello"
      },
      {
        id: 13,
        name: "Esbjörn Falk",
        releaseId: 9,
        contribution: "Composer, Violin"
      },
      {
        id: 14,
        name: "Johan Kyllmar",
        releaseId: 9,
        contribution: "Cello"
      },
      {
        id: 15,
        name: "Esbjörn Falk",
        releaseId: 10,
        contribution: "Composer, Violin"
      },
      {
        id: 16,
        name: "Esbjörn Falk",
        releaseId: 1,
        contribution: "Composer, Violin"
      },
      {
        id: 17,
        name: "Esbjörn Falk",
        releaseId: 2,
        contribution: "Composer, Violin"
      },
      {
        id: 18,
        name: "Esbjörn Falk",
        releaseId: 3,
        contribution: "Composer, Violin"
      },
      {
        id: 19,
        name: "Esbjörn Falk",   
        releaseId: 4,
        contribution: "Composer, Violin"
      },
      {
        id: 20,
        name: "Esbjörn Falk",   
        releaseId: 5,
        contribution: "Composer, Violin"
      }
  ];